import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { daysFromNow } from '@zapier/date';
import { teamsDowngradedBannerQuery as TeamsDowngradedBannerQuery } from './types/teamsDowngradedBannerQuery';

export const teamsDowngradedBannerQuery = gql`
  query teamsDowngradedBannerQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      isTeamAccount
      teamAccountEndDate
    }
  }
`;

type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<TeamsDowngradedBannerQuery>(
    teamsDowngradedBannerQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId: accountId ? parseInt(accountId) : undefined,
      },
    }
  );

  const account = data?.account;

  const daysSinceTeamDowngrade = account?.teamAccountEndDate
    ? daysFromNow(account?.teamAccountEndDate)
    : 0;

  return (
    !account?.isTeamAccount &&
    !!account?.teamAccountEndDate &&
    daysSinceTeamDowngrade <= 7
  );
};
